import * as React from 'react';
import { IsologoProps } from '..';

export const TidalIsologo: React.FC<IsologoProps> = (props) => {
  return (
    <svg width="24" height="17" viewBox="0 0 24 17" {...props}>
      <path
        fill={props.fill}
        d="M16 12l-4 4 -4-4 4-4L16 12zM4 0L0 4l4 4 4-4L4 0zM12 0L8 4l4 4 4-4L12 0zM20 0l-4 4 4 4 4-4L20 0z"
      />
    </svg>
  );
};

export default TidalIsologo;
